export interface ICustomerContact {
  primary: boolean;
  name: string;
  email: string;
  phone: string;
  mobile: string;
}

export interface ICustomerAddress {
  type: string;
  primary: boolean;
  houseno: string;
  houseadd: string;
  street: string;
  street2: string;
  city: string;
  zipcode: string;
  country: string;
}

/**
 * Customer model class
 */
export class CustomerModel {
  public _id: string;
  public contacts: ICustomerContact[];
  public addresses: ICustomerAddress[];

  constructor(
    public origin: string = '',
    public title: string = '',
    public first_name: string = '',
    public middle_name: string = '',
    public last_name: string = '',
    public newsletter_subscribe: boolean = false,
    public dob: any = undefined,
  ) {
    this.contacts = [
      <ICustomerContact>{
        primary: true,
        name: '',
        email: '',
        phone: '',
        mobile: '',
      },
    ];

    this.addresses = [
      <ICustomerAddress>{
        type: '',
        primary: true,
        houseno: '',
        houseadd: '',
        street: '',
        street2: '',
        city: '',
        zipcode: '',
        country: '',
      },
    ];
  }
}

// Hack! It makes sure that in the test scripts & test are using the same
// reference to the class
export const CustomerModelProvider = {
  provide: 'CustomerModel',
  useValue: CustomerModel,
};
